import { render, staticRenderFns } from "./DishCategories.vue?vue&type=template&id=473b7ad9&scoped=true&"
import script from "./DishCategories.vue?vue&type=script&lang=js&"
export * from "./DishCategories.vue?vue&type=script&lang=js&"
import style0 from "./DishCategories.vue?vue&type=style&index=0&id=473b7ad9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b7ad9",
  null
  
)

component.options.__file = "DishCategories.vue"
export default component.exports